angular.module("rightPaneModule")
  .directive("rightPane", ['$window', function($window) {
    return {
      restrict: "E",
      templateUrl: '/resources/right-pane/partials/right-pane.html',
      link: function ($scope, $element) {
      }
    };
  }]);
